export default {
    namespaced: true,
    state: {
        types: [],
        supplierTypes: [],
        errors: {
            getTypes: ''
        }
    },
    getters: {
        getTypeByCategory: state => id => {
            if (!id) return state.types
            return state.types.filter(item => item.CategoryID == id)
        },
        //options for supplier products page filter
        getSupplierTypesByCategories: state => ids => {
            if (!ids.length) return state.supplierTypes
            const idsArr = ids.map(id => parseInt(id))
            return state.supplierTypes.filter(
                item => idsArr.indexOf(parseInt(item.CategoryID)) !== -1
            )
        },
        //values for supplier products page filter, default all
        supplierTypesValuesArr(state) {
            return state.supplierTypes.map(type => type.TypeID)
        }
    },
    mutations: {
        SET_TYPES(state, payload) {
            state.types = payload
        },
        SET_SUPPLIER_TYPES(state, payload) {
            state.supplierTypes = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getTypes({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getTypes',
                val: ''
            })

            const url = '/public/dict/types'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                if (data && data.existing) {
                    commit('SET_SUPPLIER_TYPES', resp)
                } else {
                    commit('SET_TYPES', resp)
                }
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getTypes',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getTypes',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
